// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* End-customer sidebar. Lives inside the shell's Sider (256px, 72px collapsed) and the phone
   nav drawer; colors/heights come from the Menu tokens in design-system/theme.js. */

.nu-sidebar {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  min-width: 0;
}

.nu-sidebar__profile {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  margin: var(--ds-space-1) var(--ds-space-3) var(--ds-space-3);
  padding: var(--ds-space-3);
  border-radius: var(--ds-radius-lg);
  background: var(--ds-surface-2);
  border: 1px solid var(--ds-border-soft);
  color: var(--ds-text);
}

/* The drawer already shows the user card; a collapsed sider has no room for it. */
.app-nav-drawer .nu-sidebar__profile,
.ant-layout-sider-collapsed .nu-sidebar__profile {
  display: none;
}

.nu-sidebar__avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: linear-gradient(135deg, var(--ds-brand-500), var(--ds-brand-ink));
  color: #fff;
  font-weight: 700;
}

.nu-sidebar__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nu-sidebar__user {
  min-width: 0;
}

.nu-sidebar__name {
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.nu-sidebar__role {
  font-size: 0.8rem;
  color: var(--ds-text-2);
  overflow-wrap: anywhere;
}

.nu-sidebar__icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.nu-sidebar .ant-menu.nu-sidebar__menu {
  flex: 1 1 auto;
  border-inline-end: 0;
}

.nu-sidebar .ant-menu.nu-sidebar__logout {
  margin-top: var(--ds-space-2);
  padding-top: var(--ds-space-2);
  border-top: 1px solid var(--ds-border-soft);
  border-inline-end: 0;
}

/* The custom SVG icons don't carry antd's .ant-menu-item-icon class, so antd adds no gap. */
.nu-sidebar .nu-sidebar__icon + .ant-menu-title-content {
  margin-inline-start: var(--ds-space-3);
}

/* On the navy shell chrome (sider + drawer) */
.app-sider .nu-sidebar__profile {
  background: rgba(255, 255, 255, 0.07);
  border-color: var(--ds-chrome-border);
  color: var(--ds-chrome-text-strong);
}

.app-sider .nu-sidebar__role {
  color: var(--ds-chrome-text-muted);
}

.app-sider .nu-sidebar .ant-menu.nu-sidebar__logout,
.app-nav-drawer .nu-sidebar .ant-menu.nu-sidebar__logout {
  border-top-color: var(--ds-chrome-border);
}
`, "",{"version":3,"sources":["webpack://./src/normalUsers/components/sidebar/NormalUserSidebar.css"],"names":[],"mappings":"AAAA;oFACoF;;AAEpF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,6DAA6D;EAC7D,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA,kFAAkF;AAClF;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6EAA6E;EAC7E,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA,4FAA4F;AAC5F;EACE,sCAAsC;AACxC;;AAEA,8CAA8C;AAC9C;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,yCAAyC;AAC3C","sourcesContent":["/* End-customer sidebar. Lives inside the shell's Sider (256px, 72px collapsed) and the phone\n   nav drawer; colors/heights come from the Menu tokens in design-system/theme.js. */\n\n.nu-sidebar {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n  min-width: 0;\n}\n\n.nu-sidebar__profile {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  margin: var(--ds-space-1) var(--ds-space-3) var(--ds-space-3);\n  padding: var(--ds-space-3);\n  border-radius: var(--ds-radius-lg);\n  background: var(--ds-surface-2);\n  border: 1px solid var(--ds-border-soft);\n  color: var(--ds-text);\n}\n\n/* The drawer already shows the user card; a collapsed sider has no room for it. */\n.app-nav-drawer .nu-sidebar__profile,\n.ant-layout-sider-collapsed .nu-sidebar__profile {\n  display: none;\n}\n\n.nu-sidebar__avatar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--ds-brand-500), var(--ds-brand-ink));\n  color: #fff;\n  font-weight: 700;\n}\n\n.nu-sidebar__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.nu-sidebar__user {\n  min-width: 0;\n}\n\n.nu-sidebar__name {\n  font-weight: 600;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.nu-sidebar__role {\n  font-size: 0.8rem;\n  color: var(--ds-text-2);\n  overflow-wrap: anywhere;\n}\n\n.nu-sidebar__icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.nu-sidebar .ant-menu.nu-sidebar__menu {\n  flex: 1 1 auto;\n  border-inline-end: 0;\n}\n\n.nu-sidebar .ant-menu.nu-sidebar__logout {\n  margin-top: var(--ds-space-2);\n  padding-top: var(--ds-space-2);\n  border-top: 1px solid var(--ds-border-soft);\n  border-inline-end: 0;\n}\n\n/* The custom SVG icons don't carry antd's .ant-menu-item-icon class, so antd adds no gap. */\n.nu-sidebar .nu-sidebar__icon + .ant-menu-title-content {\n  margin-inline-start: var(--ds-space-3);\n}\n\n/* On the navy shell chrome (sider + drawer) */\n.app-sider .nu-sidebar__profile {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: var(--ds-chrome-border);\n  color: var(--ds-chrome-text-strong);\n}\n\n.app-sider .nu-sidebar__role {\n  color: var(--ds-chrome-text-muted);\n}\n\n.app-sider .nu-sidebar .ant-menu.nu-sidebar__logout,\n.app-nav-drawer .nu-sidebar .ant-menu.nu-sidebar__logout {\n  border-top-color: var(--ds-chrome-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
